module.exports = __webpack_public_path__ + "img/bank-show-mismatch.b80f6d9f.svg";